export enum HttpStatus {
  NotFound = 404,
  ServerError = 500,
  Forbidden = 403,
  NotAllowed = 405,
  BadRequest = 400,
  Conflict = 409,
  EntityTooLarge = 413,
  Unauthorized = 401,
  Timeout = 408,
  BadGateway = 502,
}

export enum HttpMethod {
  Post = 'POST',
  Put = 'PUT',
  Get = 'GET',
  Delete = 'DELETE',
  Patch = 'PATCH',
}

export const ERROR_ROUTES = {
  NotFound: 'nenalezeno',
} as const;
